/**
 * Parst QR-Code-Strings zu Spotify Track URIs
 * Unterstützt verschiedene Formate:
 * - spotify:track:ID
 * - https://open.spotify.com/track/ID
 * - https://open.spotify.com/track/ID?si=...
 * - Direkte Track-ID
 */
export function parseQrToTrackUri(qr: string): string {
  const trimmed = qr.trim();

  // Fall 1: Bereits im URI-Format
  if (trimmed.startsWith('spotify:track:')) {
    return trimmed;
  }

  // Fall 2: Spotify-Link
  if (trimmed.includes('open.spotify.com/track/')) {
    try {
      const url = new URL(trimmed);
      const pathParts = url.pathname.split('/');
      const trackIdIndex = pathParts.indexOf('track') + 1;
      
      if (trackIdIndex > 0 && trackIdIndex < pathParts.length) {
        const trackId = pathParts[trackIdIndex];
        return `spotify:track:${trackId}`;
      }
    } catch (e) {
      // Fallback: Regex-Matching
      const match = trimmed.match(/track\/([a-zA-Z0-9]+)/);
      if (match && match[1]) {
        return `spotify:track:${match[1]}`;
      }
    }
  }

  // Fall 3: Nur Track-ID (22 Zeichen alphanumerisch)
  if (/^[a-zA-Z0-9]{22}$/.test(trimmed)) {
    return `spotify:track:${trimmed}`;
  }

  // Fehlerfall
  throw new Error(`Ungültiges QR-Code-Format: ${trimmed}`);
}

/**
 * Extrahiert die Track-ID aus einer URI
 */
export function extractTrackId(uri: string): string {
  const parsed = parseQrToTrackUri(uri);
  return parsed.replace('spotify:track:', '');
}